
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';

type BreadcrumbProps = {
  title: string;
  category?: string;
};

const BlogBreadcrumb: React.FC<BreadcrumbProps> = ({ title, category }) => {
  const location = useLocation();
  
  // Handler for the Blog link when already on blog page
  const handleBlogClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    // If we're already on the blog page with a post parameter
    if (location.pathname === '/blog' && location.search.includes('post=')) {
      e.preventDefault();
      // Update URL without reloading
      window.history.pushState({}, "", "/blog");
      // Scroll to top
      window.scrollTo(0, 0);
      // Trigger a popstate event to notify the Blog component to update
      window.dispatchEvent(new PopStateEvent('popstate'));
    }
  };

  return (
    <nav aria-label="Breadcrumb" className="py-4 px-4 md:px-0 animate-fadeIn">
      <ol className="flex flex-wrap items-center text-sm text-gray-600">
        <li className="flex items-center">
          <Link to="/" className="hover:text-[#F97316] transition-colors">
            Home
          </Link>
          <ChevronRight className="mx-2 h-4 w-4 text-gray-400" />
        </li>
        <li className="flex items-center">
          <Link 
            to="/blog" 
            className="hover:text-[#F97316] transition-colors"
            onClick={handleBlogClick}
          >
            Blog
          </Link>
          <ChevronRight className="mx-2 h-4 w-4 text-gray-400" />
        </li>
        {category && (
          <li className="flex items-center">
            <span className="text-[#F97316]">{category}</span>
            <ChevronRight className="mx-2 h-4 w-4 text-gray-400" />
          </li>
        )}
        <li className="text-gray-800 font-medium hidden sm:block">
          <span className="truncate max-w-[200px] inline-block align-bottom">{title}</span>
        </li>
      </ol>
    </nav>
  );
};

export default BlogBreadcrumb;
